// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width: 64rem){.CodeScannerDialog-dialogContent__f7o3A{width:calc(var(--size-20)*6)}}.CodeScannerDialog-body__DAQfp{display:flex;flex-direction:column;gap:var(--size-4);padding:var(--size-4)}.CodeScannerDialog-placeholder__FKDg2{display:flex;align-items:center;justify-content:center;width:100%;max-height:40dvh;aspect-ratio:4/3;color:var(--pure-white-a11);font-size:var(--font-size-sm);background-color:var(--pure-black-a12);border-radius:var(--border-radius-2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogContent": "CodeScannerDialog-dialogContent__f7o3A",
	"body": "CodeScannerDialog-body__DAQfp",
	"placeholder": "CodeScannerDialog-placeholder__FKDg2"
};
export default ___CSS_LOADER_EXPORT___;
